// extracted by mini-css-extract-plugin
module.exports = {"container":"RqKs20","title":"awuWQH","content":"PPY2eI","options":"FJkPqg"};